// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
      //suggestionMode: 'test'
      //suggestionPosition: 'left',
      suggestionWidth: 300,
  }
};

(function () {
  BoostPFS.inject(this);

  // Masquer les produits avec le tag "masqué-recherche" dans la recherche instantanée
  if (typeof InstantSearchProduct !== 'undefined') {
    var originalInstantSearchCompileTemplate = InstantSearchProduct.prototype.compileTemplate;
    InstantSearchProduct.prototype.compileTemplate = function(data) {
      if (!data) data = this.data;
      // Vérifier si le produit a le tag "masqué-recherche"
      if (data.tags) {
        for (var t = 0; t < data.tags.length; t++) {
          var tag = data.tags[t].toLowerCase().trim();
          if (tag === 'masqué-recherche' || tag === 'masque-recherche') {
            return '';
          }
        }
      }
      return originalInstantSearchCompileTemplate.call(this, data);
    };
  }

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function(suggestionElement, searchElement, searchBoxId) {
    if(!suggestionElement) suggestionElement = this.suggestionElement;
    if(!searchElement) searchElement = this.searchElement;
    if(!searchBoxId) searchBoxId = this.searchBoxId;
  };

  InstantSearch.prototype.beforeBindEvents = function(id) {
    if(!id) id = this.id;
      jQ(document).ready(function() {
          jQ(document).off('submit', '.search-form, #search-form');
      });
  };

})();